import { RootState } from '@store/store.interface';

const getState = (state: RootState) => state.adminInquiries.supplementSearch;
export const adminSupplementSearchSelector = (state: RootState) =>
  getState(state).data?.tableData || [];
export const adminSupplementSearchPaginationSelector = (state: RootState) =>
  getState(state).data?.pagination;
export const adminSupplementSearchIsLoadingSelector = (state: RootState) =>
  getState(state).isLoading;
